import { isEmpty, includes, get } from "lodash";

export const addStrengthToText = (
  event,
  newValue,
  newPlainTextValue,
  mentions,
  setResponseMessageReply,
  setTaggedKeywords,
  taggedKeywordsData = [],
  plainText = false
) => {
  // const setTextObject = plainText
  //   ? newPlainTextValue
  //   : {
  //       target: {
  //         value: newPlainTextValue
  //       }
  //     };
  // let taggedKeywords = taggedKeywordsData || [];
  // mentions.forEach(tag => {
  //   taggedKeywords.push(tag.id);
  // });

  // if (isEmpty(mentions) && taggedKeywords.length) {
  //   taggedKeywords = filterKeywordDeletion(taggedKeywords, newPlainTextValue);
  // }
  const setTextObject = plainText
    ? newPlainTextValue
    : {
        target: {
          value: newPlainTextValue,
        },
      };
  let taggedKeywords = [...(taggedKeywordsData || [])];
  [...mentions].forEach((tag) => {
    taggedKeywords.push({ strengthId: tag.id, name: tag.display });
  });

  if (isEmpty(mentions) && get(taggedKeywords, "id", "").length) {
    taggedKeywords = filterKeywordDeletion(taggedKeywords, newPlainTextValue);
  }
  setTaggedKeywords(taggedKeywords);
  setResponseMessageReply(setTextObject);
};

export const filterKeywordDeletion = (taggedKeywords, newPlainTextValue) => {
  let filteredTaggedKeywords = [];

  taggedKeywords.forEach((tag) => {
    if (includes(newPlainTextValue, tag)) filteredTaggedKeywords.push(tag);
  });
  return filteredTaggedKeywords;
};

export const onEnterSubmit = (event, submitResponseButton, isEnterPressed) => {
  // if (event.keyCode === 13 && event.altKey) {
  // } else
  if (isEnterPressed) {
    event?.preventDefault?.();
    // && !event.altKey && !event.shiftKey && !event.ct) {
    submitResponseButton.current.click();
  }
};

export const addUserToText = (
  event,
  newValue,
  newPlainTextValue,
  mentions,
  setResponseMessageReply,
  setUserKeywords,
  taggedUserData = [],
  plainText = false
) => {
  const setTextObject = plainText
    ? newPlainTextValue
    : {
        target: {
          value: newPlainTextValue,
        },
      };
  let taggedKeywords = [...(taggedUserData || [])];
  [...mentions].forEach((tag) => {
    taggedKeywords.push({ userId: tag.id, name: tag.display });
  });

  if (isEmpty(mentions) && get(taggedKeywords, "id", "").length) {
    taggedKeywords = filterKeywordDeletion(taggedKeywords, newPlainTextValue);
  }
  setUserKeywords?.(taggedKeywords);
  setResponseMessageReply(setTextObject);
};
